/**
 * Mobile Drawer Accordion - Two-Column Menu Controller
 * Handles tab switching between categories and panels
 * Also handles "ALL JEWELRY" as drawer trigger on desktop
 */

document.addEventListener('DOMContentLoaded', function() {
  initMobileDrawerAccordion();
  initAllJewelryTrigger();
});

// Also re-initialize when drawer opens (for dynamic content)
document.addEventListener('click', function(e) {
  /** @type {HTMLElement|null} */
  const target = /** @type {HTMLElement|null} */ (e.target);
  if (target && (target.closest('.header__icon--menu') || target.closest('[data-all-jewelry-trigger]'))) {
    // Small delay to ensure drawer content is rendered
    setTimeout(initMobileDrawerAccordion, 100);
  }
});

/**
 * Initialize the "SHOP ALL" link as a drawer trigger on desktop
 */
function initAllJewelryTrigger() {
  // Find all menu links in the header
  /** @type {NodeListOf<HTMLElement>} */
  const menuLinks = document.querySelectorAll('header-menu .menu-list__link, .header-menu .menu-list__link');
  
  menuLinks.forEach(function(link) {
    const text = (link.textContent || '').trim().toUpperCase();
    
    // Check if this is the "ALL JEWELRY" or "SHOP ALL" link
    if (text === 'ALL JEWELRY' || text === 'SHOP ALL') {
      // Mark it as the trigger
      link.setAttribute('data-all-jewelry-trigger', 'true');
      
      // Remove aria-haspopup to prevent mega menu behavior
      link.removeAttribute('aria-haspopup');
      link.removeAttribute('aria-controls');
      link.setAttribute('aria-expanded', 'false');
      
      // Add click handler to open the drawer
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find and open the drawer
        openMenuDrawer();
      });
      
      // Also handle mouseenter to prevent mega menu from showing
      link.addEventListener('mouseenter', function(e) {
        e.stopPropagation();
        // Force aria-expanded to stay false
        link.setAttribute('aria-expanded', 'false');
      });
      
      // Add cursor style
      link.style.cursor = 'pointer';
    }
  });
}

/**
 * Opens the menu drawer programmatically
 */
function openMenuDrawer() {
  // Try to find the details element that controls the drawer
  /** @type {HTMLDetailsElement|null} */
  const detailsElement = document.querySelector('#Details-menu-drawer-container');
  
  if (detailsElement) {
    // Open the details element
    detailsElement.setAttribute('open', '');
    detailsElement.classList.add('menu-open');
    
    // Also add scroll lock to html
    document.documentElement.setAttribute('scroll-lock', '');
    
    // Initialize the accordion after drawer opens
    setTimeout(initMobileDrawerAccordion, 100);
  } else {
    // Fallback: try clicking the hamburger menu button
    /** @type {HTMLElement|null} */
    const menuButton = document.querySelector('.header__icon--menu');
    if (menuButton) {
      menuButton.click();
    }
  }
}

/**
 * Initialize the two-column accordion tabs inside the drawer
 */
function initMobileDrawerAccordion() {
  /** @type {HTMLElement|null} */
  const drawer = document.querySelector('.mm-drawer');
  if (!drawer) return;

  /** @type {NodeListOf<HTMLElement>} */
  const cats = drawer.querySelectorAll('.mm-cat');
  /** @type {NodeListOf<HTMLElement>} */
  const panels = drawer.querySelectorAll('.mm-panel');

  if (cats.length === 0 || panels.length === 0) return;

  /**
   * Function to open a panel by index
   * @param {string} idx - The tab index to open
   */
  function openPanel(idx) {
    // Update category states
    cats.forEach(function(cat) {
      const isActive = cat.dataset.mmTab === idx;
      cat.classList.toggle('is-active', isActive);
      
      const btn = cat.querySelector('.mm-cat__toggle');
      if (btn) {
        btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });

    // Update panel states
    panels.forEach(function(panel) {
      const isActive = panel.dataset.mmTab === idx;
      panel.classList.toggle('is-open', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  // Add click handlers to category toggle buttons
  cats.forEach(function(cat) {
    const idx = cat.dataset.mmTab || '0';
    const toggle = cat.querySelector('.mm-cat__toggle');
    
    // Click on toggle button opens the panel
    if (toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openPanel(idx);
      });
    }

    // Click on the entire category item (except the link) opens the panel
    cat.addEventListener('click', function(e) {
      /** @type {HTMLElement|null} */
      const target = /** @type {HTMLElement|null} */ (e.target);
      // Don't trigger if clicking the actual link
      if (target && target.classList && target.classList.contains('mm-cat__link')) {
        return;
      }
      e.preventDefault();
      openPanel(idx);
    });
  });

  // Ensure first panel is open by default if none are active
  const hasActivePanel = drawer.querySelector('.mm-panel.is-open');
  if (!hasActivePanel && panels.length > 0) {
    openPanel('0');
  }
}

// Export for potential external use
window.initMobileDrawerAccordion = initMobileDrawerAccordion;
window.initAllJewelryTrigger = initAllJewelryTrigger;
window.openMenuDrawer = openMenuDrawer;
